import { render, staticRenderFns } from "./ChangeAccountDialog.vue?vue&type=template&id=b9420a98"
import script from "./ChangeAccountDialog.vue?vue&type=script&lang=js"
export * from "./ChangeAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports